<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">预约详情</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="客户名:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="联系电话:"> {{ basicInfo.phone }} </el-form-item>
        <!-- <el-form-item label="公司地区:"> {{ basicInfo.address ? basicInfo.address.province : '' }}{{ basicInfo.address ? basicInfo.address.city : '' }}{{ basicInfo.address ? basicInfo.address.county : ''
        }} </el-form-item> -->
        <el-form-item label="预约套餐:"> {{ basicInfo.address ? basicInfo.address.fullAddress : '' }} </el-form-item>
        <!-- <el-form-item label="营业执照:">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]"></el-image>
        </el-form-item> -->
        <el-form-item label="付款情况:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="付款日期:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="备注:"> {{ basicInfo.name }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, storeQueryByStoreId, checkStoreCode, storeAuditStore } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = this.$route.query.id
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
    storeQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.phone = this.$msg.filterBridal(res.data.data.phone)
        obj.sendFlag = obj.sendFlag === undefined ? '0' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.basicInfo = obj
      }
    })
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
